var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5307 3.67847C40.5125 9.10344 26.7911 24.8199 19.1827 32C12.8861 25.0857 -2.06846 10.0605 3.04758 3.67847C7.3102 -1.63896 15.5096 7.00269 19.1827 12.4542C21.8063 7.26852 28.5489 -1.7465 34.5307 3.67847Z",
    fill: "#CF848E",
    stroke: "#CF848E",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/HeartIcon.552d1e040c99eba7408911a146daa0ec.svg";
export { ForwardRef as ReactComponent };